module.exports = __webpack_public_path__ + "static/media/1.372a38c1.jpg";